import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addRoutineDietApi, addStateApi, listOfCountryApi, listOfRoutineDietApi, listOfStateApi, updateRoutineDietApi, updateStateApi } from "../../../../../config/Api";

export const State = () => {
    const { Option } = Select;
    const [form] = Form.useForm();

    const [country, setCountry] = useState('')

    const [countriesList, setCountriesList] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [buttonName, setButtonName] = useState('ADD')
    const [stateData, setStateData] = useState()
    const [editStateRecord, setEditStateRecord] = useState()
    const [loading, setLoading] = useState(false)

    // get the list of alll available states 
    //==============================
    const getListOfStates = () => {
        setLoading(true)

        listOfStateApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // get the list of all countries 
    //==============================
    const getListOfCountries = () => {
        setLoading(true)

        listOfCountryApi()
            .then((res) => {
                if (res.status === 200) {
                    setCountriesList(res.data.data);
                    console.log("country", res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // call when user click on edit
    //==============================
    const editState = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'state_name': data.name })
        form.setFieldsValue({ 'country': data.country_id })
        setEditStateRecord(data);
    }

    useEffect(() => {
        getListOfStates()
        getListOfCountries()
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterStateList(stateData);
    }, [stateData]);

    // filter state list
    //==============================
    const filterStateList = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 || element?.country?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <p className="mb-0">{text}</p>,
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            // render: (text) => <a>{text}</a>,
            render: (text, data) => <p className="mb-0">{data?.country?.name}</p>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editState(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const data = [
        {
            id: '1',
            name: 'idli Rice',
            dietType: 'Cereals',
            status: true
        },
        {
            id: '2',
            name: 'Toor Dal',
            dietType: 'Protiens',
            status: false
        },
        {
            id: '3',
            name: 'Coffee',
            dietType: 'Beverages',
            status: true
        },
        {
            id: '4',
            name: 'Cabbage',
            dietType: 'Vegetables',
            status: true
        },
        {
            id: '5',
            name: 'Apple',
            dietType: 'Fruits',
            status: true
        },
    ];

    const CountryOptions = [
        { id: 1, country_name: 'India' },
        { id: 2, country_name: 'US' },
        { id: 3, country_name: 'Russia' },
        { id: 4, country_name: 'UAE' }
    ]

    // handle submit
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.state_name,
                "country_id": values.country,
                "status": true
            }
            addStateApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'state_name': '' })
                        form.setFieldsValue({ 'country': '' })
                        notification.success({
                            message: "State added successfully",
                        });
                        getListOfStates()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.state_name,
                "country_id": values.country,
                "status": values.status
            }
            updateStateApi(editStateRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "State Update successfully",
                        });
                        getListOfStates()
                        form.setFieldsValue({ 'state_name': '' })
                        form.setFieldsValue({ 'country': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="RoutineDiet">
            <Row>
                <Col xl={14}>
                    <Form
                        name="AddRoutineDietForm"
                        className="AddRoutineDietForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row>
                            <Col xl={8}>
                                <Form.Item
                                    name="country"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Country!",
                                        },
                                    ]}
                                    initialValue={1}
                                >
                                    <Select
                                        // value={regType}
                                        defaultValue={1}
                                        showSearch
                                        filterOption={(inputValue, option) =>
                                            option?.children?.toLowerCase().includes(inputValue?.toLowerCase())
                                        }
                                    >
                                        <Option value="" disabled hidden>
                                            Select Country
                                        </Option>
                                        {
                                            countriesList && countriesList.length > 0 && countriesList.map((option) =>
                                                <Option value={option.id}>{option.name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="state_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter State Name!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter State Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={7}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}>
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    {/* <h6>{tagCategory ?  `Total ${tagCategory}` : "Total Tags"  }</h6> */}
                    <h6> Total : {displayData.length > 0 ? displayData.length : 0}   </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search State"
                        onChange={(e) => { filterStateList(e.target.value); setStateData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
